import { render, staticRenderFns } from "./PageDetail.vue?vue&type=template&id=7cef36b1"
import script from "./PageDetail.vue?vue&type=script&lang=js"
export * from "./PageDetail.vue?vue&type=script&lang=js"
import style0 from "./PageDetail.vue?vue&type=style&index=0&id=7cef36b1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports